import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import get from 'lodash-es/get';
import { Subject } from 'rxjs';

import { CalendarsService } from '../../services/calendars.service';
import { Location } from '@finder/features/calendars/calendars.interface';
import { CommonModule } from '@angular/common';
import { ParkCardComponent } from './components/park-card/park-card.component';

@Component({
    selector: 'finder-calendar-month',
    templateUrl: './day.component.html',
    styleUrls: ['./day.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ParkCardComponent,
    ]
})
export class CalendarDayComponent implements OnInit, OnDestroy {

    data: any;
    fullDateString: string;
    formattedDate: string;
    locations: Array<Location>;

    private destroy$ = new Subject<void>();

    constructor(
        private route: ActivatedRoute,
        private calendarsService: CalendarsService
    ) { }

    ngOnInit() {
        this.data = get(this.route.snapshot.parent.data, 'calendar');
        this.calendarsService.watchLocations()
            .pipe(takeUntil(this.destroy$))
            .subscribe(locations => {
                this.fullDateString = this.calendarsService.fullDateString;
                this.formattedDate = this.calendarsService.formattedDate;
                this.locations = locations;
            });
    }

    ngOnDestroy() {
        // Ignore the if just for coverage, there's no need to test unsubscribe
        /* istanbul ignore next */
        this.destroy$.next();
        this.destroy$.complete();
    }
}
